// https://stackoverflow.com/a/33292942/7982963
export default function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
